import { trackEventAsync, generateRequiredProperties } from './index';

export default {
  trackUpdatedAppointmentComplianceEvent: (
    patientId: string,
    date: string,
    value: string,
  ): Promise<void> =>
    trackEventAsync({
      ...generateRequiredProperties(),
      eventName: 'Appointment Compliance Update by Clinician',
      eventProperties: {
        patientId: patientId,
        appointmentDate: date,
        value,
      },
    }),

  trackUpdatedCleanScreenEvent: (
    patientId: string | null,
    date: string | null,
    value: string,
  ): Promise<void> =>
    trackEventAsync({
      ...generateRequiredProperties(),
      eventName: 'Urine Screen Results Update by Clinician',
      eventProperties: {
        value,
        patientId,
        testDate: date,
      },
    }),

  trackVisitedClinicDialogEvent: (
    patientId: string,
    warning: string,
    action: string,
  ): Promise<void> =>
    trackEventAsync({
      ...generateRequiredProperties(),
      eventName: `Clinic Visit Dialog ${action}`,
      eventProperties: { patientId, warning },
    }),
};
